module.exports = __webpack_public_path__ + "static/media/lifeline_step_3_neg.9f9c77e3.png";